// extracted by mini-css-extract-plugin
export default {"sider":"index_sider__d3Mmp","logoutWrapper":"index_logoutWrapper__MPA+P","logout":"index_logout__c+Qq9"};